// 홈 카드와 같이 할인율, 정가, 받을 금액만 한 줄로 보여 준다. 주문 금액·상품 번호·영수증은 기존 결제 코드가 관리한다.
(() => {
  if (globalThis.BGOFFER) return;
  const reference = (value) => (globalThis.BGTOSSUI?.referencePrices ?? { 3300: 9900, 9900: 19900, 19900: 39900 })[value] || null;
  const parse = (text) => {
    const match = String(text ?? '').trim().match(/^(?:(?:[₩￦]|KRW)\s*)?([\d,]+)\s*원?$/);
    return match ? Number(match[1].replaceAll(',', '')) : [3300, 9900, 19900].find(value => globalThis.BGLANG?.money?.(value) === String(text ?? '').trim()) ?? null;
  };
  const won = (value, sale) => globalThis.BGLANG?.money?.(value, sale) || (globalThis.BGLANG?.locale && globalThis.BGLANG.locale !== 'ko' ? new Intl.NumberFormat(globalThis.BGLANG.locale,{style:'currency',currency:'KRW',currencyDisplay:'code',maximumFractionDigits:0}).format(value) : Number(value).toLocaleString('ko-KR') + '원');
  const t = (text) => globalThis.BGLANG?.t(text) ?? text;
  const discount = (value, base) => {
    const amount = price => Number(globalThis.BGLANG?.quote?.(price, value)?.value);
    const sale = amount(value), original = amount(base);
    return Math.round((original > 0 && Number.isFinite(sale) ? 1 - sale / original : 1 - value / base) * 100);
  };
  const html = (value) => {
    const base = reference(value);
    if (!base) return null;
    const rate = discount(value, base);
    return `<span class="bw-offer" data-i18n-skip=""><b class="bw-offer-rate">${rate}%</b><span class="bw-offer-reference"><span>${won(base, value)}</span></span><span class="bw-offer-sale"><strong>${won(value)}</strong></span></span>`;
  };
  function paintButton(button, value, label) {
    const formatted = /구매하기$/.test(label) || label === t('구매하기') ? html(value) : null;
    if (formatted) {
      const locale = globalThis.BGLANG?.locale || 'ko';
      const revision = String(globalThis.BGLANG?.revision ?? 0);
      if (button.dataset.bwOfferLabel !== label || button.dataset.bwOfferPrice !== String(value) || button.dataset.bwOfferLocale !== locale || button.dataset.bwOfferRevision !== revision || button.dataset.bwOfferVersion !== String(globalThis.BGTOSSUI?.version ?? 0) || !button.querySelector(':scope > .bw-offer')) button.innerHTML = formatted;
      button.classList.add('bw-offer-button');
      const base = reference(value);
      button.setAttribute('aria-label', base ? `${t(label)} ${discount(value, base)}% ${won(base, value)} ${won(value)}` : `${t(label)} ${won(value)}`);
      button.dataset.bwOfferAria = '1';
      button.dataset.bwOfferLabel = label;
      button.dataset.bwOfferPrice = String(value);
      button.dataset.bwOfferLocale = globalThis.BGLANG?.locale || 'ko';
      button.dataset.bwOfferRevision = String(globalThis.BGLANG?.revision ?? 0);
      button.dataset.bwOfferVersion = String(globalThis.BGTOSSUI?.version ?? 0);
    } else {
      if (button.textContent !== t(label)) button.textContent = t(label);
      button.classList.remove('bw-offer-button');
      if (button.dataset.bwOfferAria) { button.removeAttribute('aria-label'); delete button.dataset.bwOfferAria; }
      delete button.dataset.bwOfferLabel;
      delete button.dataset.bwOfferPrice;
      delete button.dataset.bwOfferLocale;
      delete button.dataset.bwOfferRevision;
    }
  }
  globalThis.BGOFFER = Object.freeze({ reference, parse, html, paintButton });
  if (typeof document === 'undefined') return;
  const selector = '#payBtn > .cn, .dock-price, .price-line > .price, .dialog-price > strong';
  const seen = new WeakMap();
  function dockButton(node) {
    const button = node.closest('.dock')?.querySelector('[data-buy]');
    if (!button) return;
    const label = button.querySelector(':scope > .bw-offer') ? button.dataset.bwOfferLabel : button.textContent.trim();
    paintButton(button, seen.get(node), label || '구매하기');
  }
  function apply(node) {
    if (!node?.matches?.(selector)) return;
    if (node.querySelector(':scope > .bw-offer') && seen.has(node)) { dockButton(node); return; }
    const price = parse(node.textContent), formatted = html(price);
    if (!formatted) {
      node.classList.remove('bw-offer-host');
      node.closest('#payBtn')?.classList.remove('bw-offer-button');
      seen.delete(node);
      dockButton(node);
      return;
    }
    node.innerHTML = formatted;
    node.classList.add('bw-offer-host');
    seen.set(node, price);
    dockButton(node);
    const button = node.closest('#payBtn');
    if (button) button.classList.add('bw-offer-button');
  }
  function scan(root) {
    if (root?.matches?.(selector)) apply(root);
    root?.querySelectorAll?.(selector).forEach(apply);
  }
  const pending = new Set();
  let frame = 0;
  function queue(node) {
    if (node?.nodeType === 3) node = node.parentElement;
    if (!node?.querySelectorAll) return;
    const button = node.closest('#payBtn');
    if (button && !button.querySelector('.cn.bw-offer-host')) button.classList.remove('bw-offer-button');
    const owner = node.closest(selector);
    const dockPrice = node.closest('.dock')?.querySelector('.dock-price');
    if (dockPrice) pending.add(dockPrice);
    if (owner) pending.add(owner);
    if (node.matches(selector)) pending.add(node);
    node.querySelectorAll(selector).forEach(n => pending.add(n));
    if (!pending.size || frame) return;
    frame = requestAnimationFrame(() => { frame = 0; const items = [...pending]; pending.clear(); items.filter(n => n.isConnected).forEach(apply); });
  }
  function start() {
    scan(document.body);
    const refresh = () => {
      document.querySelectorAll(selector).forEach(node => { if (seen.has(node)) node.textContent = won(seen.get(node)); });
      scan(document.body);
      document.querySelectorAll('[data-bw-offer-label]').forEach(button => paintButton(button, Number(button.dataset.bwOfferPrice), button.dataset.bwOfferLabel));
    };
    document.addEventListener('bamgwabi:toss-ui', refresh);
    document.addEventListener('bamgwabi:locale-change', refresh);
    new MutationObserver(changes => {
      for (const change of changes) {
        queue(change.target);
        if (change.type === 'childList') change.addedNodes.forEach(queue);
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
